import axiosRetry, { isIdempotentRequestError } from 'axios-retry'

export const DEFAULT_AXIOS_RETRY_CONFIG = {
  retryDelay: axiosRetry.exponentialDelay,
  retries: 4,
  shouldResetTimeout: true,
  retryCondition: error => {
    try {
      const retry =
        error.code === 'ECONNABORTED' ||
        isIdempotentRequestError(error) ||
        (error?.response?.status >= 500 &&
          error.config.url?.indexOf('/logos') >= 0)

      return retry
    } catch (_e) {
      return false
    }
  },
}

/**
 * Attaches the provided retry config to axios.
 *
 * @param {AxiosStatic | AxiosInstance} axios
 * @param {import('axios-retry').IAxiosRetryConfig} retryConfig
 */
export const AxiosRetryFactory = (
  axios,
  retryConfig = DEFAULT_AXIOS_RETRY_CONFIG
) => {
  axiosRetry(axios, retryConfig)
}
